import { BlockTitle } from "@blocks/Blocks";
import SmallCard from "@pages/Global/components/SmallCard";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { SanitizedSectionArticle } from "@typings/Cue";
import { cn } from "@util/helpers";

type LatestNewsSectionProps = {
  /** The latest news articles to be displayed in the section */
  articles: SanitizedSectionArticle[];
  /** Optional className for the section */
  className?: string;
};

/**
 * LatestNewsSection component to display a list of latest news articles.
 * It renders a section with a title and a list of articles as SmallCard components.
 */
const LatestNewsSection = ({
  articles,
  className,
}: LatestNewsSectionProps): React.ReactElement => {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  if (!articles.length) return <></>;

  return (
    <section
      data-testid="latest-news-section-component"
      className={cn(
        "-mx-3 w-svw bg-gray-125 p-4 md:mx-0 md:w-full lg:mt-0",
        className
      )}
    >
      <BlockTitle text={"LATEST"} />

      {articles.map((article, index) => (
        <SmallCard
          key={index}
          article={article}
          displayUpdated
          contentClassName="px-0"
          className="my-4"
          linkParams={new URLSearchParams({ ref: "global-latest" })}
          disablePaywall={
            OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER
          }
        />
      ))}
    </section>
  );
};

export default LatestNewsSection;
